const features = [
  {
    id: 1,
    title: '多线路防屏蔽',
    desc: '配备多重备用域名与智能跳转系统，主线路异常时自动切换至可用入口，确保51吃瓜网址随时随地稳定访问。',
    icon: 'ri-shield-check-line',
    color: 'bg-primary-50 text-primary-600',
  },
  {
    id: 2,
    title: '每日实时更新',
    desc: '内容团队全天候追踪最新热点，51吃瓜网址新入口与八卦资讯同步刷新，绝不错过任何一个劲爆大瓜。',
    icon: 'ri-refresh-line',
    color: 'bg-accent-50 text-accent-600',
  },
  {
    id: 3,
    title: '全网内容聚合',
    desc: '一站聚合娱乐圈、网红圈、体育圈、科技圈等热门话题，51吃瓜官网全网最新内容智能分类，高效浏览。',
    icon: 'ri-stack-line',
    color: 'bg-secondary-50 text-secondary-600',
  },
  {
    id: 4,
    title: '安全免费使用',
    desc: '无需注册登录，不收集个人数据，纯导航平台完全免费。51吃瓜网站入口仅提供信息导航，安全省心。',
    icon: 'ri-lock-line',
    color: 'bg-primary-50 text-primary-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">平台特色</h2>
          <p className="text-foreground-600 text-sm md:text-base">为什么选择51吃瓜网址？四大优势为你护航</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 border border-background-200/60 rounded-xl p-6 hover:border-primary-200/50 transition-all duration-300 group cursor-pointer text-center"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl ${feature.color} mx-auto mb-4`}>
                <i className={`${feature.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}